// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"255":"24763c3e","552":"da585802","605":"a06e78fc","719":"a3bda84f","780":"b4c3adf7","886":"d37a5017"}[chunkId] + ".chunk.css";
};